<div class="trips-card" [class.trips-card-row]="!banner">
  @if (banner) {
    <img class="trips-banner" [src]="cityImage" [alt]="title" (error)="onImageError($event)" />
  }

  <div class="trips-body d-flex align-items-stretch">
    @if (!banner) {
      <div class="trips-thumb-wrap">
        <img class="trips-thumb" [src]="cityImage" [alt]="title" (error)="onImageError($event)" />
      </div>
    }

    <div class="d-flex align-items-center flex-1 p-4 p-md-5">
      <div class="flex-1">
        @if (title) {
          <h2 class="semi-bold" data-id="trip-title">{{ title }}</h2>
        }

        <div class="d-flex flex-wrap align-items-center trips-meta mt-2">
          @if (dateLabel) {
            <span class="d-flex align-items-center" data-id="trip-dates">
              <img src="assets/icons/calendar_today.svg" alt="" width="16" height="16" />
              <p class="ml-2">{{ dateLabel }}</p>
            </span>
          }

          @if (travelerLabel) {
            <span class="d-flex align-items-center" data-id="trip-travelers">
              <img src="assets/icons/travelers.svg" alt="" width="16" height="16" />
              <p class="ml-2">{{ travelerLabel }}</p>
            </span>
          }

          @if (routeLabel) {
            <span class="d-flex align-items-center trips-route" data-id="trip-route">
              <img src="assets/icons/flight_takeoff.svg" alt="" width="16" height="16" />
              <p class="trips-route-text ml-2">{{ routeLabel }}</p>
            </span>
          }
        </div>
      </div>

      @if (banner) {
        <img
          class="trips-chevron ml-3"
          src="assets/icons/chevron_right.svg"
          alt=""
          width="24"
          height="24"
        />
      }
    </div>
  </div>
</div>
